var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({..._vm.backgroundColor, ..._vm.shadow, ..._vm.border, ..._vm.radius, ..._vm.fullPaddingSubject(_vm.section.options.customize.style, 'padding', [20,20,20,20]), ..._vm.fullMarginSubject(_vm.section.options.customize.style)})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }